import React, { useState } from "react";
import styles from "../commanstyles.module.css";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";

function Auditor({ isSubScribe, apiData, apiData2, costData, statutoryData, secretarialData }) {
  // const [isStandaloneOpen, setIsStandaloneOpen] = useState(true);
  // const [isConsolidatedOpen, setIsConsolidatedOpen] = useState(true);
  const [isStatutoryAuditorOpen, setIsStatutoryAuditorOpen] = useState(true);
  const [isSecretarialAuditorOpen, setIsSecretarialAuditorOpen] = useState(true);
  const [isCostAuditorOpen, setIsCostAuditorOpen] = useState(true);

  // const toggleStandalone = () => {
  //   setIsStandaloneOpen((prev) => !prev);
  // };

  // const toggleConsolidated = () => {
  //   setIsConsolidatedOpen((prev) => !prev);
  // };

  const toggleStatutoryAuditor = () => {
    setIsStatutoryAuditorOpen((prev) => !prev);
  };

  const toggleSecretarialAuditor = () => {
    setIsSecretarialAuditorOpen((prev) => !prev);
  };

  const toggleCostAuditor = () => {
    setIsCostAuditorOpen((prev) => !prev);
  };

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className={styles.table_subcontainer}>
      {/* Standalone Section */}
      {/* <div
        className={styles.highlet_header_content1}
      
      >
        <p className={styles.minuse_icon}   onClick={toggleStandalone}>
          {isStandaloneOpen ? (
            <FaMinusSquare size={22} />
          ) : (
            <FaPlusSquare size={22} />
          )}
        </p>
        <h3 className={styles.highlet_text}>Standalone</h3>
      </div>
      {isStandaloneOpen && isSubScribe && (
        <table className={styles.commantable}>
          <thead>
            <tr className={styles.tableHeaderRow}>
              <th className={styles.tableHeader}>Year</th>
              <th className={styles.tableHeader}>Auditor Name</th>
              <th className={styles.tableHeader}>Auditor Firm Name</th>
              <th className={styles.tableHeader}>PAN</th>
              <th className={styles.tableHeader}>Address</th>
              <th className={styles.tableHeader}>CIN</th>
              <th className={styles.tableHeader}>Membership No</th>
              <th className={styles.tableHeader}>Registration No</th>
            </tr>
          </thead>
          <tbody>
            {apiData && apiData.length > 0 ? (
              apiData.map((item, index) => (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.tableCell}>{item.year || "-"}</td>
                  <td className={styles.tableCell}>{item.auditor_name || "-"}</td>
                  <td className={styles.tableCell}>{item.auditor_firmName || "-"}</td>
                  <td className={styles.tableCell}>{item.PAN || "-"}</td>
                  <td className={styles.tableCell}>{item.address || "-"}</td>
                  <td className={styles.tableCell}>{item.CIN || "-"}</td>
                  <td className={styles.tableCell}>{item.membership_no || "-"}</td>
                  <td className={styles.tableCell}>{item.registration_no || "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className={styles.noData}>
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )} */}

      {/* Consolidated Section */}
      {/* <div
        className={styles.highlet_header_content1}
      
      >
        <p className={styles.minuse_icon}  onClick={toggleConsolidated}>
          {isConsolidatedOpen ? (
            <FaMinusSquare size={22} />
          ) : (
            <FaPlusSquare size={22} />
          )}
        </p>
        <h3 className={styles.highlet_text}>Consolidated</h3>
      </div>
      {isConsolidatedOpen && isSubScribe && (
        <table className={styles.commantable}>
          <thead>
            <tr className={styles.tableHeaderRow}>
              <th className={styles.tableHeader}>Year</th>
              <th className={styles.tableHeader}>Auditor Name</th>
              <th className={styles.tableHeader}>Auditor Firm Name</th>
              <th className={styles.tableHeader}>PAN</th>
              <th className={styles.tableHeader}>Address</th>
              <th className={styles.tableHeader}>CIN</th>
              <th className={styles.tableHeader}>Membership No</th>
              <th className={styles.tableHeader}>Registration No</th>
            </tr>
          </thead>
          <tbody>
            {apiData2 && apiData2.length > 0 ? (
              apiData2.map((item, index) => (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.tableCell}>{item.year || "-"}</td>
                  <td className={styles.tableCell}>{item.auditor_name || "-"}</td>
                  <td className={styles.tableCell}>{item.auditor_firmName || "-"}</td>
                  <td className={styles.tableCell}>{item.PAN || "-"}</td>
                  <td className={styles.tableCell}>{item.address || "-"}</td>
                  <td className={styles.tableCell}>{item.CIN || "-"}</td>
                  <td className={styles.tableCell}>{item.membership_no || "-"}</td>
                  <td className={styles.tableCell}>{item.registration_no || "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className={styles.noData}>
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )} */}

      {/* Statutory Auditor Section */}
      <div
        className={styles.highlet_header_content1}
      >
        <p className={styles.minuse_icon} onClick={toggleStatutoryAuditor}>
          {isStatutoryAuditorOpen ? (
            <FaMinusSquare size={22} />
          ) : (
            <FaPlusSquare size={22} />
          )}
        </p>
        <h3 className={styles.highlet_text}>Statutory Auditor</h3>
      </div>
      {isStatutoryAuditorOpen && isSubScribe && (
        <table className={styles.commantable}>
          <thead>
            <tr className={styles.tableHeaderRow}>
              {/* <th className={styles.tableHeader}>Year</th> */}
              <th className={styles.tableHeader}>Auditor Name</th>
              <th className={styles.tableHeader}>Auditor Firm Name</th>
              <th className={styles.tableHeader}>PAN</th>
              <th className={styles.tableHeader}>Address</th>
              <th className={styles.tableHeader}>Membership No</th>
              <th className={styles.tableHeader}>Registration No</th>
              <th className={styles.tableHeader}>Email</th>
              <th className={styles.tableHeader}>From Date</th>
              <th className={styles.tableHeader}>To Date</th>
              <th className={styles.tableHeader}>Reference Document</th>
            </tr>
          </thead>
          <tbody>
            {statutoryData && statutoryData.length > 0 ? (
              statutoryData.map((item, index) => (
                <tr key={index} className={styles.tableRow}>
                  {/* <td className={styles.tableCell}>{item.year || "-"}</td> */}
                  <td className={styles.tableCell}>{item.auditor_name || "-"}</td>
                  <td className={styles.tableCell}>{item.auditor_firmName || "-"}</td>
                  <td className={styles.tableCell}>{item.PAN || "-"}</td>
                  <td className={styles.tableCell}>{item.address || "-"}</td>
                  <td className={styles.tableCell}>{item.membership_no || "-"}</td>
                  <td className={styles.tableCell}>{item.registration_no || "-"}</td>
                  <td className={styles.tableCell}>{item.email || "-"}</td>
                  <td className={styles.tableCell}>{formatDate(item.fromDate)}</td>
                  <td className={styles.tableCell}>{formatDate(item.toDate)}</td>
                  <td className={styles.tableCell}>
                    {item.refDoc?.fileurl ? (
                      <a href={item.refDoc.fileurl} target="_blank" rel="noopener noreferrer">
                        View Document
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" className={styles.noData}>
                  No Statutory Auditor Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}

      {/* Secretarial Auditor Section */}
      <div
        className={styles.highlet_header_content1}

      >
        <p className={styles.minuse_icon} onClick={toggleSecretarialAuditor}>
          {isSecretarialAuditorOpen ? (
            <FaMinusSquare size={22} />
          ) : (
            <FaPlusSquare size={22} />
          )}
        </p>
        <h3 className={styles.highlet_text}>Secretarial Auditor</h3>
      </div>
      {isSecretarialAuditorOpen && isSubScribe && (
        <table className={styles.commantable}>
          <thead>
            <tr className={styles.tableHeaderRow}>
              {/* <th className={styles.tableHeader}>Year</th> */}
              <th className={styles.tableHeader}>Secretarial Auditor Name</th>
              <th className={styles.tableHeader}>Secretarial Auditor Firm Name</th>
              <th className={styles.tableHeader}>Address</th>
              <th className={styles.tableHeader}>Membership No</th>
              <th className={styles.tableHeader}>Peer Review No</th>
              <th className={styles.tableHeader}>From Date</th>
              <th className={styles.tableHeader}>To Date</th>
              <th className={styles.tableHeader}>Reference Document</th>
            </tr>
          </thead>
          <tbody>
            {secretarialData && secretarialData.length > 0 ? (
              secretarialData.map((item, index) => (
                <tr key={index} className={styles.tableRow}>
                  {/* <td className={styles.tableCell}>{item.year || "-"}</td> */}
                  <td className={styles.tableCell}>{item.auditor_name || "-"}</td>
                  <td className={styles.tableCell}>{item.auditor_firmName || "-"}</td>
                  <td className={styles.tableCell}>{item.address || "-"}</td>
                  <td className={styles.tableCell}>{item.membership_no || "-"}</td>
                  <td className={styles.tableCell}>{item.review || "-"}</td>
                  <td className={styles.tableCell}>{formatDate(item.fromDate)}</td>
                  <td className={styles.tableCell}>{formatDate(item.toDate)}</td>
                  <td className={styles.tableCell}>
                    {item.refDoc?.fileurl ? (
                      <a href={item.refDoc.fileurl} target="_blank" rel="noopener noreferrer">
                        View Document
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className={styles.noData}>
                  No Secretarial Auditor data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}

      {/* Cost Auditor Section */}
      <div
        className={styles.highlet_header_content1}

      >
        <p className={styles.minuse_icon} onClick={toggleCostAuditor}>
          {isCostAuditorOpen ? (
            <FaMinusSquare size={22} />
          ) : (
            <FaPlusSquare size={22} />
          )}
        </p>
        <h3 className={styles.highlet_text}>Cost Auditor</h3>
      </div>
      {isCostAuditorOpen && isSubScribe && (
        <table className={styles.commantable}>
          <thead>
            <tr className={styles.tableHeaderRow}>
              {/* <th className={styles.tableHeader}>Year</th> */}
              <th className={styles.tableHeader}>Auditor Name</th>
              <th className={styles.tableHeader}>Cost Auditor Firm Name</th>
              <th className={styles.tableHeader}>Address</th>
              <th className={styles.tableHeader}>Firm Registration Number</th>
              <th className={styles.tableHeader}>Email id of the Firm/ Cost auditor</th>
              <th className={styles.tableHeader}>From Date</th>
              <th className={styles.tableHeader}>To Date</th>
              <th className={styles.tableHeader}>Reference Document</th>
            </tr>
          </thead>
          <tbody>
            {costData && costData.length > 0 ? (
              costData.map((item, index) => (
                <tr key={index} className={styles.tableRow}>
                  {/* <td className={styles.tableCell}>{item.year || "-"}</td> */}
                  <td className={styles.tableCell}>{item.auditor_name || "-"}</td>
                  <td className={styles.tableCell}>{item.auditor_firmName || "-"}</td>
                  <td className={styles.tableCell}>{item.address || "-"}</td>
                  <td className={styles.tableCell}>{item.registration_no || "-"}</td>
                  <td className={styles.tableCell}>{item.email || "-"}</td>
                  <td className={styles.tableCell}>{formatDate(item.fromDate)}</td>
                  <td className={styles.tableCell}>{formatDate(item.toDate)}</td>
                  <td className={styles.tableCell}>
                    {item.refDoc?.fileurl ? (
                      <a href={item.refDoc.fileurl} target="_blank" rel="noopener noreferrer">
                        View Document
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className={styles.noData}>
                  No Cost Auditor data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default Auditor;
